import axiosInstance from "@/api/axiosInstance";
import {
  CreatePaymentRequestRequest,
  CreatePaymentRequestResponse,
} from "./types";

export async function createPaymentRequest(
  data: CreatePaymentRequestRequest,
): Promise<CreatePaymentRequestResponse> {
  const response = await axiosInstance.post(
    `/api/private/payment-requests`,
    data,
  );
  return response.data?.data ?? response.data;
}
